import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-4.347 12.038","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

/**
 * IconLocationMinus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbG9jYXRpb24tbWludXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDE4bC0yIC00bC03IC0zLjVhLjU1IC41NSAwIDAgMSAwIC0xbDE4IC02LjVsLTQuMzQ3IDEyLjAzOCIgLz4KICA8cGF0aCBkPSJNMTYgMTloNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/location-minus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLocationMinus = createReactComponent('outline', 'location-minus', 'LocationMinus', __iconNode);

export default IconLocationMinus;